import React, { useState, useEffect } from 'react';
import { SdmCircularLoader } from './SdmCircularLoader';
import { useNetwork } from 'services/network';

const placeholder = '/themes/custom/sdm/images/header/logo-black.svg';
export const SdmImage = ({
  url,
  styleContainer = {
    width: 100,
    height: 100,
    display: 'flex',
    alignItems: 'center',
  },
  styleContainerPlaceholder = { width: 150 },
  styleImg = {
    maxWidth: 100,
    maxHeight: 100,
    objectFit: 'cover',
  },
  styleImgPlaceholder = { maxWidth: 180 },
  ...rest
}) => {
  const networkHelper = useNetwork();

  const [fetchedImage, setFetchedImage] = useState(placeholder);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    fetchImage(url);
  }, [url]);

  const hasPlaceholder = () => {
    return fetchedImage === placeholder;
  };

  const fetchImage = async () => {
    setLoaded(false);
    try {
      if (url) {
        const res = await networkHelper.getImage(url);
        if (res.data) {
          const raw = Buffer.from(res.data, 'binary').toString('base64');
          const logoUrl = `data:${res.headers['content-type']};base64,${raw}`;
          setFetchedImage(logoUrl);
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      setFetchedImage(placeholder);
    }
    setLoaded(true);
  };

  return (
    <div
      style={{
        ...styleContainer,
        ...(hasPlaceholder() && { ...styleContainerPlaceholder }),
      }}
    >
      <div style={{ width: '100%' }}>
        {!loaded ? (
          <SdmCircularLoader style={{ position: 'absolute' }} />
        ) : (
          <img
            src={fetchedImage}
            style={{
              ...styleImg,
              ...(hasPlaceholder() && { ...styleImgPlaceholder }),
            }}
            {...rest}
          ></img>
        )}
      </div>
    </div>
  );
};
